import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withFormik, Form } from 'formik';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import styled from 'styled-components';
import { submitProfileAndGenerateWorkout } from '../../../services/apiServices';
import { getResources } from '../../../modules/Resource';
import { setGlobalLoadingSpinner } from '../../../modules/GlobalUI';

const Container = styled.div`
  display: flex;
  flex: 1;
  overflow: auto;
`;
const SubContainer = styled.div`
  margin-bottom: 16px;
`;
const WorkoutContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const WorkoutButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
const FormStyled = styled(Form)`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
const FormControlStyled = styled(FormControl)`
  margin: 0 4px;
  min-width: 200px;
`;
const RowStyled = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
`;
const ColumnStyled = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
  margin: 2px;
`;
const ColumnHeader = styled(ColumnStyled)`
  font-size: 20px;
  font-weight: 600;
  text-align: center;
`;
const TableHeader = styled.h3`
  display: flex;
  justify-content: center;
  margin: 0;
`;
const TableSubHeader = styled.h4`
  display: flex;
  justify-content: center;
  margin: 0;
`;

class Workouts extends Component {
  constructor(props) {
    super(props)
    this.ageRef= React.createRef()
    this.feetRef= React.createRef()
    this.inchesRef= React.createRef()
    this.weightRef= React.createRef()
    this.state = {
      dayView: '0-0',
      error: false,
      profile: null,
      values: null,
      workout: null,
      workouts: null,
      workout_title: '',
      validation: {
        age:false,
        feet:false,
        inches:false,
        weight:false,
      }
    };
  }

  async componentDidMount() {
    const { getResources, resourceState } = this.props;

    if (!resourceState.resourceData) {
      await getResources();
    }
  }

  changeTracker = (value, name) => this.props.setFieldValue(name, value, true);

  handleSubmit = async (values) => {
    values.height = {
      feet: values.feet,
      inches: values.inches,
    };

    // input validation

   const requiredFields = [this.ageRef, this.feetRef, this.inchesRef, this.weightRef];
    for (const field of requiredFields) {
      if (!field.current.value) {
          field.current.focus()
          field.current.scrollIntoView(false)
          this.setState({ validation: { ...this.state.validation, [field.current.name]: true } });
          return;
      }
    }

    this.props.setGlobalLoadingSpinner(true, 'getting results...');

    try {
      // submit values == profile to get a workout...
      const { profile, workouts } = await submitProfileAndGenerateWorkout(values, values.target);

      const goal = profile.training_goal.split('_');
      const workout_title = [];

      for (const word of goal) {
        workout_title.push(word.charAt(0).toUpperCase() + word.slice(1));
      }

      this.setState({
        error: false,
        profile,
        values: values,
        workout: workouts[0].workouts[0],
        workouts,
        workout_title: workout_title.join(' '),
      });
    } catch(e) {
      this.setState({
        error: true,
        workout: null,
      });
    }

    this.props.setGlobalLoadingSpinner(false);

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  gotoProfile = () => {
    this.setState({
      workout: null
    });
  }

  generateAnother = async () => {
    const { values } = this.state;

    try {
      const { profile, workouts } = await submitProfileAndGenerateWorkout(values, values.target);

      this.setState({
        dayView: '0-0',
        workout: workouts[0].workouts[0],
        workouts,
      });
    } catch(e) {
      this.setState({
        error: true,
        workout: null,
      });
    }

    this.props.setGlobalLoadingSpinner(false);
  }

  handleDayChange = (evt) => {
    const dayView = evt.target.value;
    const { workouts } = this.state;

    const weekIndex = dayView.substring(0, dayView.indexOf('-'));
    const dayIndex = dayView.substring(dayView.indexOf('-') + 1);

    this.setState({
      dayView,
      workout: workouts[weekIndex].workouts[dayIndex],
    });
  }

  render() {
    const {
      values,
      handleChange,
    } = this.props;

    const { dayView, error, profile, workout, workouts, workout_title } = this.state;

    return (
      <Container>
        { workout == null && (
          <FormStyled>
            <SubContainer>
              <FormControlStyled>
                <InputLabel htmlFor='program-length'>Program Length</InputLabel>
                <Select
                  value={values.program_length}
                  onChange={handleChange}
                  inputProps={{
                    id: 'program-length',
                    name: 'program_length'
                  }}
                >
                  <MenuItem key={`4-weeks`} value={4}>4 Weeks</MenuItem>
                  <MenuItem key={`8-weeks`} value={8}>8 Weeks</MenuItem>
                  <MenuItem key={`12-weeks`} value={12}>12 Weeks</MenuItem>
                </Select>
              </FormControlStyled>

              <FormControlStyled>
                <InputLabel htmlFor='workout-days'># Days a Week</InputLabel>
                <Select
                  value={values.workout_days}
                  onChange={handleChange}
                  inputProps={{
                    id: 'workout-days',
                    name: 'workout_days'
                  }}
                >
                  <MenuItem key={`1-day`} value={1}>1</MenuItem>
                  <MenuItem key={`2-day`} value={2}>2</MenuItem>
                  <MenuItem key={`3-day`} value={3}>3</MenuItem>
                  <MenuItem key={`4-day`} value={4}>4</MenuItem>
                  <MenuItem key={`5-day`} value={5}>5</MenuItem>
                  <MenuItem key={`6-day`} value={6}>6</MenuItem>
                </Select>
              </FormControlStyled>

              <FormControlStyled>
                <InputLabel htmlFor='workout-length'>Workout Length</InputLabel>
                <Select
                  value={values.workout_length}
                  onChange={handleChange}
                  inputProps={{
                    id: 'workout-length',
                    name: 'workout_length'
                  }}
                >
                  <MenuItem key={`30-minutes`} value={30}>30 Minutes</MenuItem>
                  <MenuItem key={`60-minutes`} value={60}>60 Minutes</MenuItem>
                </Select>
              </FormControlStyled>
            </SubContainer>

            <SubContainer>
              <FormControlStyled>
                <InputLabel htmlFor='available-equipment'>Available Equipment</InputLabel>
                <Select
                  value={values.available_equipment}
                  onChange={handleChange}
                  inputProps={{
                    id: 'available-equipment',
                    name: 'available_equipment'
                  }}
                >
                  <MenuItem key={`equipment-1`} value={1}>No Equipment - Bodyweight Only</MenuItem>
                  <MenuItem key={`equipment-2`} value={2}>Superbands, Mini-Bands, Foam Roller and Yoga Block</MenuItem>
                  <MenuItem key={`equipment-3`} value={3}>Superbands, Mini-Bands, Foam Roller, Yoga Block, Dumbbells and Kettlebells</MenuItem>
                  <MenuItem key={`equipment-4`} value={4}>Full Fitness Facility</MenuItem>
                </Select>
              </FormControlStyled>

              <FormControlStyled>
                <InputLabel htmlFor='training-goal'>Training Goal</InputLabel>
                <Select
                  value={values.training_goal}
                  onChange={handleChange}
                  inputProps={{
                    id: 'training-goal',
                    name: 'training_goal'
                  }}
                >
                  <MenuItem key={`fat-burning`} value={`fat_burning`}>Fat Burning</MenuItem>
                  <MenuItem key={`muscle-buildiing`} value={`muscle_building`}>Muscle Building</MenuItem>
                  <MenuItem key={`athletic-conditioning`} value={`athletic_conditioning`}>Athletic Conditioning</MenuItem>
                  <MenuItem key={`flexibility`} value={`flexibility`}>Flexibility</MenuItem>
                </Select>
              </FormControlStyled>
            </SubContainer>

           <SubContainer>
             <FormControlStyled>
                <InputLabel htmlFor='age'>Age</InputLabel>
                <Input
                  inputRef={this.ageRef}
                  error= {this.state.validation.age && values.age ===''}
                  id='age'
                  name='age'
                  type='number'
                  value={values.age}
                  onChange={handleChange}
                  required={true}
                />
              </FormControlStyled>

              <FormControlStyled>
                <InputLabel htmlFor='gender'>Gender</InputLabel>
                <Select
                  value={values.gender}
                  onChange={handleChange}
                  inputProps={{
                    id: 'gender',
                    name: 'gender'
                  }}
                >
                  <MenuItem key={`male`} value={`male`}>Male</MenuItem>
                  <MenuItem key={`female`} value={`female`}>Female</MenuItem>
                </Select>
              </FormControlStyled>

              <FormControlStyled style={{ width: '350px' }}>
                <InputLabel htmlFor='pregnant'>Have you been pregnant or delivered a child within the last year?</InputLabel>
                <Select
                  value={values.pregnant}
                  onChange={handleChange}
                  inputProps={{
                    id: 'pregnant',
                    name: 'pregnant'
                  }}
                  disabled={values.gender === 'male'}
                >
                  <MenuItem key={`yes`} value={`yes`}>Yes</MenuItem>
                  <MenuItem key={`no`} value={`no`}>No</MenuItem>
                </Select>
              </FormControlStyled>
            </SubContainer>

           <SubContainer>
             <FormControlStyled>
                <InputLabel htmlFor='feet'>Height - Feet</InputLabel>
                <Input
                  inputRef={this.feetRef}
                  error= {this.state.validation.feet && values.feet ===''}
                  id='feet'
                  name='feet'
                  type='number'
                  value={values.feet}
                  onChange={handleChange}
                  required={true}
                />
              </FormControlStyled>

             <FormControlStyled>
                <InputLabel htmlFor='inches'>Height - Inches</InputLabel>
                <Input
                  inputRef={this.inchesRef}
                  error= {this.state.validation.inches && values.inches ===''}
                  id='inches'
                  name='inches'
                  type='number'
                  value={values.inches}
                  onChange={handleChange}
                  required={true}
                />
              </FormControlStyled>

             <FormControlStyled>
                <InputLabel htmlFor='weight'>Weight (Pounds)</InputLabel>
                <Input
                  inputRef={this.weightRef}
                  error= {this.state.validation.weight && values.weight ===''}
                  label="error"
                  id='weight'
                  name='weight'
                  type='number'
                  value={values.weight}
                  onChange={handleChange}
                  required={true}
                />
              </FormControlStyled>
            </SubContainer>

            <SubContainer style={{ marginTop: '16px' }}>
              <b>Functional Measurements</b>
            </SubContainer>

            <SubContainer>
              <FormControlStyled>
                <InputLabel htmlFor='fm-upper'>Upper Body Flexibility and Stiffness</InputLabel>
                <Select
                  value={values.fm_upper}
                  onChange={handleChange}
                  inputProps={{
                    id: 'fm-upper',
                    name: 'fm_upper'
                  }}
                >
                  <MenuItem key={`fm-upper-1`} value={1}>(1) I am in pain and do not move well</MenuItem>
                  <MenuItem key={`fm-upper-2`} value={2}>(2) I am not in pain, but I feel stiff and inflexible</MenuItem>
                  <MenuItem key={`fm-upper-3`} value={3}>(3) I have average flexibility and only feel stiff after exercise</MenuItem>
                  <MenuItem key={`fm-upper-4`} value={4}>(4) I currently have a high level of flexibility and no pain</MenuItem>
                </Select>
              </FormControlStyled>
            </SubContainer>

            <SubContainer>
              <FormControlStyled>
                <InputLabel htmlFor='fm-lower'>Lower Body Flexibility and Stiffness</InputLabel>
                <Select
                  value={values.fm_lower}
                  onChange={handleChange}
                  inputProps={{
                    id: 'fm-lower',
                    name: 'fm_lower'
                  }}
                >
                  <MenuItem key={`fm-lower-1`} value={1}>(1) I am in pain and do not move well</MenuItem>
                  <MenuItem key={`fm-lower-2`} value={2}>(2) I am not in pain, but I feel stiff and inflexible</MenuItem>
                  <MenuItem key={`fm-lower-3`} value={3}>(3) I have average flexibility and only feel stiff after exercise</MenuItem>
                  <MenuItem key={`fm-lower-4`} value={4}>(4) I currently have a high level of flexibility and no pain</MenuItem>
                </Select>
              </FormControlStyled>
            </SubContainer>

            <SubContainer>
              <FormControlStyled>
                <InputLabel htmlFor='fm-core'>Core Stability</InputLabel>
                <Select
                  value={values.fm_core}
                  onChange={handleChange}
                  inputProps={{
                    id: 'fm-core',
                    name: 'fm_core'
                  }}
                >
                  <MenuItem key={`fm-core-1`} value={1}>(1) I have pain in my back and neck daily</MenuItem>
                  <MenuItem key={`fm-core-2`} value={2}>(2) I do not feel strong enough to maintain good posture throughout the day</MenuItem>
                  <MenuItem key={`fm-core-3`} value={3}>(3) My core is trained, but could get better</MenuItem>
                  <MenuItem key={`fm-core-4`} value={4}>(4) I have dedicated a lot of time to training my core in the past</MenuItem>
                </Select>
              </FormControlStyled>
            </SubContainer>

            <SubContainer>
              <FormControlStyled>
                <InputLabel htmlFor='fm-familiar'>Exercise Familiarity</InputLabel>
                <Select
                  value={values.fm_familiar}
                  onChange={handleChange}
                  inputProps={{
                    id: 'fm-familiar',
                    name: 'fm_familiar'
                  }}
                >
                  <MenuItem key={`fm-familiar-1`} value={1}>(1) I do not exercise regularly and do not feel "good" at it</MenuItem>
                  <MenuItem key={`fm-familiar-2`} value={2}>(2) I have exercised in the past but felt like I was doing things wrong</MenuItem>
                  <MenuItem key={`fm-familiar-3`} value={3}>(3) I work out frequently and feel like I mostly understand how to exercise</MenuItem>
                  <MenuItem key={`fm-familiar-4`} value={4}>(4) I am very confident in knowing how to perform the exercises I do</MenuItem>
                </Select>
              </FormControlStyled>
            </SubContainer>

            <SubContainer style={{ marginTop: '16px' }}>
              <b>Fitness Score</b>
            </SubContainer>

            <SubContainer>
              <FormControlStyled>
                <InputLabel htmlFor='fs-cardio'>Cardiovascular Level</InputLabel>
                <Select
                  value={values.fs_cardio}
                  onChange={handleChange}
                  inputProps={{
                    id: 'fs-cardio',
                    name: 'fs_cardio'
                  }}
                >
                  <MenuItem key={`fs-cardio-1`} value={1}>(1) I struggle to complete continuous exercise of any duration</MenuItem>
                  <MenuItem key={`fs-cardio-2`} value={2}>(2) I can walk / job / bike for 10 - 20 minutes continuously</MenuItem>
                  <MenuItem key={`fs-cardio-3`} value={3}>(3) I can run / bike / swim intensely for 30 - 45 minutes continuously</MenuItem>
                  <MenuItem key={`fs-cardio-4`} value={4}>(4) I frequently run / bike / swim for durations exceeding one hour</MenuItem>
                </Select>
              </FormControlStyled>
            </SubContainer>

            <SubContainer>
              <FormControlStyled>
                <InputLabel htmlFor='fs-strength'>Strength Level</InputLabel>
                <Select
                  value={values.fs_strength}
                  onChange={handleChange}
                  inputProps={{
                    id: 'fs-strength',
                    name: 'fs_strength'
                  }}
                >
                  <MenuItem key={`fs-strength-1`} value={1}>(1) I have never trained with weights above 20% of my bodyweight</MenuItem>
                  <MenuItem key={`fs-strength-2`} value={2}>(2) I regularly train with weights, but never above 50% of my bodyweight</MenuItem>
                  <MenuItem key={`fs-strength-3`} value={3}>(3) I regularly train with weights equal to or above 100% of my bodyweight</MenuItem>
                  <MenuItem key={`fs-strength-4`} value={4}>(4) I emphasize training with weights that exceed my bodyweight</MenuItem>
                </Select>
              </FormControlStyled>
            </SubContainer>

            <SubContainer>
              <FormControlStyled>
                <InputLabel htmlFor='fs-density'>Weekly Workout Density</InputLabel>
                <Select
                  value={values.fs_density}
                  onChange={handleChange}
                  inputProps={{
                    id: 'fs-density',
                    name: 'fs_density'
                  }}
                >
                  <MenuItem key={`fs-density-1`} value={1}>(1) I exercised 0 - 1 times per week over the last 3 months</MenuItem>
                  <MenuItem key={`fs-density-2`} value={2}>(2) I exercised 2 - 3 times per week over the last 3 months</MenuItem>
                  <MenuItem key={`fs-density-3`} value={3}>(3) I exercised 4 - 5 times per week over the last 3 months</MenuItem>
                  <MenuItem key={`fs-density-4`} value={4}>(4) I exercised 6 - 7 times per week over the last 3 months</MenuItem>
                </Select>
              </FormControlStyled>
            </SubContainer>

            <SubContainer>
              <FormControlStyled>
                <InputLabel htmlFor='fs-intensity'>Typical Workout Intensity</InputLabel>
                <Select
                  value={values.fs_intensity}
                  onChange={handleChange}
                  inputProps={{
                    id: 'fs-intensity',
                    name: 'fs_intensity'
                  }}
                >
                  <MenuItem key={`fs-intensity-1`} value={1}>(1) When I exercise, I stop when it begins to become uncomfortable</MenuItem>
                  <MenuItem key={`fs-intensity-2`} value={2}>(2) When I exercise, I get sweaty and feel some difficulty</MenuItem>
                  <MenuItem key={`fs-intensity-3`} value={3}>(3) When I exercise, I push myself to sweat and burn a lot of calories</MenuItem>
                  <MenuItem key={`fs-intensity-4`} value={4}>(4) when I exercise, I push myself to muscular and metabolic fatigue</MenuItem>
                </Select>
              </FormControlStyled>
            </SubContainer>

            <SubContainer style={{ marginTop: '16px' }}>
              <b>Performance Score</b>
            </SubContainer>

            <SubContainer>
              <FormControlStyled>
                <InputLabel htmlFor='ps-impact'>High Impact</InputLabel>
                <Select
                  value={values.ps_impact}
                  onChange={handleChange}
                  inputProps={{
                    id: 'ps-impact',
                    name: 'ps_impact'
                  }}
                >
                  <MenuItem key={`ps-impact-1`} value={1}>(1) I do not wish to perform jumping, springing or explosive movements</MenuItem>
                  <MenuItem key={`ps-impact-2`} value={2}>(2) I am uncomfortable with high impact exercises, but will try</MenuItem>
                  <MenuItem key={`ps-impact-3`} value={3}>(3) I do some plyometrics and other explosive movements</MenuItem>
                  <MenuItem key={`ps-impact-4`} value={4}>(4) I regularly train with plyometrics and explosive movements</MenuItem>
                </Select>
              </FormControlStyled>
            </SubContainer>

            <SubContainer>
              <FormControlStyled>
                <InputLabel htmlFor='ps-metcon'>Met-Con</InputLabel>
                <Select
                  value={values.ps_metcon}
                  onChange={handleChange}
                  inputProps={{
                    id: 'ps-metcon',
                    name: 'ps_metcon'
                  }}
                >
                  <MenuItem key={`ps-metcon-1`} value={1}>(1) I feel unable to complete a 60 second round of high intensity effort</MenuItem>
                  <MenuItem key={`ps-metcon-2`} value={2}>(2) I could complete a 60 second round of high intensity effort</MenuItem>
                  <MenuItem key={`ps-metcon-3`} value={3}>(3) I could complete multiple 60 second rounds of high intensity effort</MenuItem>
                  <MenuItem key={`ps-metcon-4`} value={4}>(4) I typically train using high intensity intervals of 120 seconds or more</MenuItem>
                </Select>
              </FormControlStyled>
            </SubContainer>

            <SubContainer>
              <FormControlStyled>
                <InputLabel htmlFor='ps-saq'>SAQ</InputLabel>
                <Select
                  value={values.ps_saq}
                  onChange={handleChange}
                  inputProps={{
                    id: 'ps-saq',
                    name: 'ps_saq'
                  }}
                >
                  <MenuItem key={`ps-saq-1`} value={1}>(1) I do not feel it is necessary to train my sporting skills for my goals</MenuItem>
                  <MenuItem key={`ps-saq-2`} value={2}>(2) I do not train these athletic qualities, but would do so</MenuItem>
                  <MenuItem key={`ps-saq-3`} value={3}>(3) I occasionally train my athletic trains with specific exercises and drills</MenuItem>
                  <MenuItem key={`ps-saq-4`} value={4}>(4) I frequently train and prioritize my athletic skill set</MenuItem>
                </Select>
              </FormControlStyled>
            </SubContainer>

            <SubContainer>
              <FormControlStyled>
                <InputLabel htmlFor='ps-balance'>Balance</InputLabel>
                <Select
                  value={values.ps_balance}
                  onChange={handleChange}
                  inputProps={{
                    id: 'ps-balance',
                    name: 'ps_balance'
                  }}
                >
                  <MenuItem key={`ps-balance-1`} value={1}>(1) I do not feel comfortable balancing on a single leg / arm and struggle with coordination</MenuItem>
                  <MenuItem key={`ps-balance-2`} value={2}>(2) I do not exercise using single leg / arm methods and could benefit from improving my coordination</MenuItem>
                  <MenuItem key={`ps-balance-3`} value={3}>(3) I occasionally train using unilateral training methods and do complex movements</MenuItem>
                  <MenuItem key={`ps-balance-4`} value={4}>(4) I frequently train unilateral and incorporate advanced body positions in my training</MenuItem>
                </Select>
              </FormControlStyled>
            </SubContainer>

            <SubContainer>
              <FormControlStyled>
                <InputLabel htmlFor='target'>Target</InputLabel>
                <Select
                  value={values.target}
                  onChange={handleChange}
                  inputProps={{
                    id: 'target',
                    name: 'target'
                  }}
                >
                  <MenuItem key={`target-1`} value={1}>Upper</MenuItem>
                  <MenuItem key={`target-2`} value={2}>Lower</MenuItem>
                  <MenuItem key={`target-3`} value={3}>Core</MenuItem>
                  <MenuItem key={`target-4`} value={4}>Global</MenuItem>
                </Select>
              </FormControlStyled>
            </SubContainer>

            <SubContainer>
              <Button color="primary" variant="contained" onClick={() => this.handleSubmit(values)}>Generate Program</Button>
            </SubContainer>
          </FormStyled>
        )}

        { !!workout && (
          <WorkoutContainer>

          <SubContainer>
            <TableHeader>Profile Calculations</TableHeader>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell>Age Restrictions</TableCell>
                  <TableCell>{profile.age_restrictions}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Pregnancy</TableCell>
                  <TableCell>{profile.pregnancy}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>BMI</TableCell>
                  <TableCell>{profile.bmi}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Functional Intensity</TableCell>
                  <TableCell>{profile.functional_intensity}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Fitness Intensity</TableCell>
                  <TableCell>{profile.fitness_intensity}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Performance Intensity</TableCell>
                  <TableCell>{profile.performance_intensity}</TableCell>
                </TableRow>
                <TableRow><TableCell colSpan={2}>&nbsp;</TableCell></TableRow>
                <TableRow>
                  <TableCell>Functional Intensity</TableCell>
                  <TableCell>Level {profile.functional_intensity_level}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>&nbsp;&nbsp;Upper Body Flexibility and Stiffness</TableCell>
                  <TableCell>{profile.func_upper}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>&nbsp;&nbsp;Lower Body Flexibility and Stiffness</TableCell>
                  <TableCell>{profile.func_lower}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>&nbsp;&nbsp;Core Stability</TableCell>
                  <TableCell>{profile.func_core}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>&nbsp;&nbsp;Exercise Familiarity</TableCell>
                  <TableCell>{profile.func_familiar}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Fitness Level</TableCell>
                  <TableCell>Level {profile.fitness_intensity_level}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>&nbsp;&nbsp;Strength Level</TableCell>
                  <TableCell>{profile.fit_strength}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>&nbsp;&nbsp;Cardiovascular Level</TableCell>
                  <TableCell>{profile.fit_cardio}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Performance Intensity</TableCell>
                  <TableCell>Level {profile.performance_intensity_level}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>&nbsp;&nbsp;High Impact</TableCell>
                  <TableCell>{profile.perf_impact}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>&nbsp;&nbsp;Met-Con</TableCell>
                  <TableCell>{profile.perf_metcon}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>&nbsp;&nbsp;SAQ</TableCell>
                  <TableCell>{profile.perf_saq}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>&nbsp;&nbsp;Balance</TableCell>
                  <TableCell>{profile.perf_balance}</TableCell>
                </TableRow>
                <TableRow><TableCell colSpan={2}>&nbsp;</TableCell></TableRow>
                <TableRow>
                  <TableCell>Final Skill Level</TableCell>
                  <TableCell>{profile.final_skill_level}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </SubContainer>

          <SubContainer>
            <WorkoutButtonContainer>
              <Button color="primary" variant="contained" onClick={this.gotoProfile}>Change Profile</Button>
              <Button color="primary" variant="contained" onClick={this.generateAnother}>Generate Another Program</Button>
            </WorkoutButtonContainer>
          </SubContainer>

          <SubContainer style={{ display: 'flex', justifyContent: 'center' }}>
            <FormControlStyled>
              <Select
                value={dayView}
                onChange={this.handleDayChange}
                inputProps={{
                  id: 'day-view',
                  name: 'day_view'
                }}
              >
                {workouts.map((week, weekIndex) => {
                  return week.workouts.map((day, dayIndex) => {
                    return (
                      <MenuItem key={`day-view-${weekIndex}-${dayIndex}`} value={`${weekIndex}-${dayIndex}`}>Week {weekIndex + 1} - Day {dayIndex + 1} - {day.focus} Focus</MenuItem>
                    )
                  })
                })}
              </Select>
            </FormControlStyled>
          </SubContainer>

          <SubContainer>
            <TableHeader>Warm Up</TableHeader>
            <TableSubHeader>Level {profile.final_skill_level}</TableSubHeader>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Block</TableCell>
                  <TableCell align="right">Exercise</TableCell>
                  <TableCell align="right">Sets</TableCell>
                  <TableCell align="right">Duration</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {workout.warm_up.map((item, index) => {
                  return (
                    <TableRow key={`warm_up-${index}`}>
                      <TableCell>{item.emphasis}</TableCell>
                      <TableCell align="right">{item.exercise}</TableCell>
                      <TableCell align="right">{item.sets}</TableCell>
                      <TableCell align="right">{item.duration}</TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </SubContainer>

          <SubContainer>
            <TableHeader>Performance Exercises</TableHeader>
            <TableSubHeader>Level {profile.final_skill_level}</TableSubHeader>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Block</TableCell>
                  <TableCell align="right">Exercise</TableCell>
                  <TableCell align="right">Sets</TableCell>
                  <TableCell align="right">Duration</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {workout.performance.map((item, index) => {
                  return item.rest ? (
                    <TableRow key={`performance-${index}`}>
                      <TableCell align="center" colSpan={4}>{item.duration} Second Rest</TableCell>
                    </TableRow>
                  ) : (
                    <TableRow key={`performance-${index}`}>
                      <TableCell>Block</TableCell>
                      <TableCell align="right">{item.exercise}</TableCell>
                      <TableCell align="right">{item.sets}</TableCell>
                      <TableCell align="right">{item.duration}</TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </SubContainer>

          <SubContainer>
            <TableHeader>{workout_title} Program</TableHeader>
            <TableSubHeader>Level {profile.final_skill_level} - {profile.workout_length} minutes</TableSubHeader>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Block</TableCell>
                  <TableCell align="right">Exercise</TableCell>
                  <TableCell align="right">Sets</TableCell>
                  <TableCell align="right">Duration</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {workout.workout.map((item, index) => {
                  return (
                    <TableRow key={`workout-${index}`}>
                      <TableCell>Circuit {item.circuit}</TableCell>
                      <TableCell align="right">{item.exercise}</TableCell>
                      <TableCell align="right">{item.sets}</TableCell>
                      <TableCell align="right">{'reps' in item ? item.reps : item.duration}</TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </SubContainer>

          <SubContainer>
            <TableHeader>Cool Down</TableHeader>
            <TableSubHeader>Level {profile.final_skill_level}</TableSubHeader>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Block</TableCell>
                  <TableCell align="right">Exercise</TableCell>
                  <TableCell align="right">Sets</TableCell>
                  <TableCell align="right">Duration</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {workout.cooldown.map((item, index) => {
                  return (
                    <TableRow key={`coodown-${index}`}>
                      <TableCell>{item.emphasis}</TableCell>
                      <TableCell align="right">{item.exercise}</TableCell>
                      <TableCell align="right">{item.sets}</TableCell>
                      <TableCell align="right">{item.duration}</TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </SubContainer>

          </WorkoutContainer>
        )}
        { error && (
          <SubContainer>
            <RowStyled>
              <ColumnHeader>Error getting results. Try again.</ColumnHeader>
            </RowStyled>
          </SubContainer>
        )}
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    resourceState: state.resourceState,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getResources: getResources,
    setGlobalLoadingSpinner: setGlobalLoadingSpinner,
  }, dispatch)
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withFormik({
  mapPropsToValues: props =>
    Object.assign(props.initialValues
      ? props.initialValues
      : {
          'program_length': 4,
          'workout_days': 4,
          'workout_length': 30,
          'available_equipment': 1,
          'training_goal': 'fat_burning',
          'age': '',
          'gender': 'male',
          'pregnant': 'no',
          'feet': '',
          'inches': '',
          'weight': '',
          'fm_upper': 1,
          'fm_lower': 1,
          'fm_core': 1,
          'fm_familiar': 1,
          'fs_cardio': 1,
          'fs_strength': 1,
          'fs_density': 1,
          'fs_intensity': 1,
          'ps_impact': 1,
          'ps_metcon': 1,
          'ps_saq': 1,
          'ps_balance': 1,
          'target': 1,
        }),

  handleSubmit: (event,values, { props, setSubmitting }) => {
    setSubmitting(false);
  },

  displayName: 'BasicForm',
}))(Workouts);
